export default __webpack_public_path__ + "static/media/team-mobile.86395b1b.webp";